enum GrantType {
    PASSWORD = 'password',
    REFRESH_TOKEN = 'refresh_token',
}

export default GrantType;
